import { ExternalLinkIcon, inforBlueIcon, ShowLessIcon, ShowMoreIcon } from '@/shared/ui/assets';
import { MultiEmailInputV2, CustomButton, CustomInput } from '@/shared/ui/components';
import _ from 'lodash';
import { t } from 'ttag';
import { useChangeStudyInformation } from './useChangeStudyInformation';
import SEND_REQUEST from '../submitARequest.constants';
import type { ChangeStudyInformationProps } from './changeStudyInformation.types';
import './styles.scss';

const ChangeStudyInformation = ({
  category,
  selectedFacility,
  setLoadingPage,
  backToPrevious,
}: ChangeStudyInformationProps) => {
  const {
    state,
    setState,
    onStudyIdChange,
    validateStudyId,
    onChange,
    onChangeEmailList,
    onInputChange,
    onClickSendMessage,
    isSubmitDisabled,
  } = useChangeStudyInformation({ category, selectedFacility, setLoadingPage, backToPrevious });

  return (
    <div className="change-study-information-tab">
      <div className="study-id-box">
        <span className="big-title">{t`Request information`}</span>
        <div className="study-id-field">
          <CustomInput
            title={t`Study ID`}
            className="study-id-input"
            placeholder={t`Enter study ID`}
            value={state.studyId}
            onChange={onStudyIdChange}
            name="studyId"
            allowClear={false}
            onBlur={validateStudyId}
            onPressEnter={validateStudyId}
            size="middle"
            isError={!!state.studyIdError}
            errorMessage={state.studyIdError}
            loading={state.isValidating}
            hasLoading
          />
          {state.validatedStudy && (
            <div className="study-found-info">
              <img src={inforBlueIcon} alt="" className="info-icon" />
              <div className="study-found-info-content">
                <div className="info-text">
                  <span className="info-heading">{t`Update your study information directly`}</span>
                  <span className="info-message">
                    {t`Edit your study details directly in the system - no request needed. Changes apply and reports regenerate automatically.`}
                  </span>
                </div>
                <CustomButton
                  className="study-management-link"
                  type="outline"
                  size="small"
                  isRightIcon
                  icon={<img src={ExternalLinkIcon} alt="" className="external-link-icon" />}
                  onClick={() => window.open(`/studies/${state.validatedStudy.id}`)}
                >
                  {t`Open study ${state.studyId}`}
                </CustomButton>
              </div>
            </div>
          )}
        </div>
      </div>

      {!_.isEmpty(state.validatedStudy) && (
        <div className="send-anyway-section">
          <span className="send-anyway-prompt">{t`Report still not updated, or have another issue?`}</span>
          <CustomButton
            type="secondary"
            size="small"
            block
            onClick={() => setState({ isFormExpanded: !state.isFormExpanded })}
          >
            <>
              Fill out the request form
              {state.isFormExpanded ? (
                <img src={ShowLessIcon} alt="Show less ic" />
              ) : (
                <img src={ShowMoreIcon} alt="Show more ic" />
              )}
            </>
          </CustomButton>

          {state.isFormExpanded && (
            <>
              <div className="message-box">
                <span className="small-title">{t`Message`}</span>
                <CustomInput
                  className="message-text"
                  placeholder={t`Enter your message`}
                  type="textarea"
                  value={state.message}
                  onChange={onChange}
                  name="message"
                  aria-label={t`Message`}
                  allowClear={false}
                />
              </div>

              <div className="email-box">
                <span className="small-title">{t`Notification email`}</span>
                <MultiEmailInputV2
                  emailList={state.emailList}
                  emailInputValue={state.emailInputValue}
                  onChangeEmailList={onChangeEmailList}
                  onInputChange={onInputChange}
                  isError={!_.isEmpty(state.errorObject.invalidEmails)}
                  errorMessage={state.errorObject.invalidEmails}
                />
              </div>
            </>
          )}
        </div>
      )}
      <div className="bottom-button-row">
        <CustomButton
          id="submit-btn"
          className="button-submit"
          disabled={isSubmitDisabled}
          onClick={() => setTimeout(onClickSendMessage, 100)}
        >
          {SEND_REQUEST}
        </CustomButton>
      </div>
    </div>
  );
};

export default ChangeStudyInformation;
